import { useQuery } from "@tanstack/react-query";
import axiosBaseURL from "..";
import { AuthContextValue, useAuth } from "../../providers/AuthProvider";

export const useGetVouchers = () => {
  const { user } = useAuth() as AuthContextValue;
  return useQuery({
    queryKey: ["useGetVouchers"],
    staleTime: 120,
    queryFn: async () => {
      const result = await axiosBaseURL.get(`/voucher/list`, {
        headers: {
          header: `${user?.userId}/${user?.token}`,
        },
      });

      return result;
    },
  });
};

export const useGetVoucherById = (id?: string) => {
  const { user } = useAuth() as AuthContextValue;
  return useQuery({
    queryKey: ["useGetVoucherById"],
    staleTime: 120,
    enabled: false,
    queryFn: async () => {
      const result = await axiosBaseURL.get(`/voucher/${id}/details`, {
        headers: {
          header: `${user?.userId}/${user?.token}`,
        },
      });

      return result;
    },
  });
};
